import React from "react";
import "./ContactPageMap.css";

const ContactPageMap = () => {
  return (
    <div className="ContactPageMap-container">
      <div className="ContactPageMap-map">
        <iframe
          className="ContactPageMap-iframe"
          src="https://www.google.com/maps?q=13/1+Redhills+Road,+Ramdass+Nagar,+Kolathur,+Chennai+600099&output=embed"
          allowFullScreen=""
          loading="lazy"
          width="600"
          height="450"
          style={{ border: 0 }}
        ></iframe>

        <div className="ContactPageMap-marker">
          <div className="ContactPageMap-marker-icon">
            <i className="bi bi-geo-alt-fill"></i>
          </div>
          <div className="ContactPageMap-info-box">
            <h5>Address:</h5>
            <p>
              #13/1, Redhills Road, Ramdass Nagar, Kolathur, Chennai – 600099.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactPageMap;
